/* About page — scroll reveal (IntersectionObserver, unobserve once shown),
   background video etiquette (pause offscreen, respect reduced motion). */

(function () {
  'use strict';

  if (window.__aboutBooted) return;
  window.__aboutBooted = true;

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = root.querySelectorAll('.about-reveal, .about-reveal-scale');
    if (!els.length) return;

    if (REDUCED_MOTION) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  function initVideos(root) {
    var videos = root.querySelectorAll('.about-page video');
    videos.forEach(function (video) {
      if (REDUCED_MOTION) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      });
      observer.observe(video);
    });
  }

  // Parallax cloud/overlay images. Two formulas, matching the source design:
  //   "cloud"  -> translateY(60% - progress*30%)  (Q&A bottom cloud)
  //   "bottom" -> translateY(-progress*80px)      (Quote banner bottom overlay)
  // progress = how far the element's own section has scrolled through the
  // viewport (0 = section top just entered, 1 = section fully scrolled past).
  var parallaxEls = null;

  function updateParallax() {
    if (!parallaxEls || !parallaxEls.length) return;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var section = el.closest('.about-page');
      if (!section) return;
      var rect = section.getBoundingClientRect();
      var progress = 1 - rect.bottom / (vh + rect.height);
      progress = Math.max(0, Math.min(1, progress));
      var type = el.getAttribute('data-about-parallax');
      // Both types also fade out as the section scrolls past — the clouds
      // are meant to be transient atmosphere, not linger over the content
      // once a visitor has moved on from that section.
      var fadedOpacity = Math.max(0, 0.85 * (1 - progress * 1.15));
      if (type === 'cloud') {
        el.style.transform = 'translateY(' + (60 - progress * 30) + '%)';
        el.style.opacity = fadedOpacity;
      } else if (type === 'bottom') {
        el.style.transform = 'translateY(' + (-(progress * 80)) + 'px)';
        el.style.opacity = fadedOpacity;
      }
    });
  }

  function initParallax(root) {
    parallaxEls = document.querySelectorAll('[data-about-parallax]');
    if (!parallaxEls.length || REDUCED_MOTION) return;
    updateParallax();
    window.addEventListener('scroll', updateParallax, { passive: true });
    window.addEventListener('resize', updateParallax);
  }

  function boot(root) {
    root = root || document;
    initReveal(root);
    initVideos(root);
    initParallax(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
